import { SnowballFight } from "./event";

export const locationsBirmingham: SnowballFight[] = [
  {
    id: "fa4f9c7d-7028-4d6b-9366-00ce364584fa",
    position: {
      long: -1.87653,
      lat: 52.45579,
    },
    date: new Date(2024, 12, 26, 7, 45, 0),
    name: "Los Tacos",
    description: "Secret snowball fight event",
  },

  {
    id: "ea63e815-5da0-4f62-8c3a-5d940ac7843c",
    position: {
      long: -1.94216,
      lat: 52.52922,
    },
    date: new Date(2024, 12, 26, 9, 30, 0),
    name: "Hall Academy",
    description: "Academy for the best snowball fighters",
  },

  {
    id: "067328cc-421a-4362-b590-68efa4dbc134",
    position: {
      long: -1.84773,
      lat: 52.43717,
    },
    date: new Date(2024, 12, 26, 11, 45, 0),
    name: "Hall Green Station",
    description: "Trains and snowball fights",
  },

  {
    id: "1eb6f562-f71d-49c9-aaa3-48aaffeb1968",
    position: {
      long: -1.78058,
      lat: 52.49516,
    },
    date: new Date(2024, 12, 26, 13, 45, 0),
    name: "Kelly's Dharma Dogs",
    description: "Dogs and snowballs",
  },

  {
    id: "8b334b34-524f-4b35-ae38-9779216a54b5",
    position: {
      long: -1.92867,
      lat: 52.49218,
    },
    date: new Date(2024, 12, 26, 20, 45, 0),
    name: "Recycling Lives",
    description: "Recycling snowballs",
  },

  {
    id: "cab2e431-beee-427e-a06d-07ca64c0c2c3",
    position: {
      long: -1.90226,
      lat: 52.46575,
    },
    date: new Date(2024, 12, 26, 22, 45, 0),
    name: "McDonald's",
    description: "McFights. Join to find out more.",
  },
];
